module.exports = __webpack_public_path__ + "img/fo.329cbed5.svg";